import React from "react";
import { render } from "react-dom";
import { AppContainer } from "react-hot-loader";
import * as Sentry from "@sentry/browser";
import Push from "push.js"
import { message, notification } from "antd"

import "codemirror/mode/javascript/javascript.js"

import "codemirror/lib/codemirror.css"
import "./data/styles/antd.less";
import "./data/styles/index.scss";

import Root from "./root";
import configureStore from "./data/store/configureStore";
import history from "./data/store/history";
import getInitialStates from "./data/redux/initial_states";
import { SENTRY_DSN } from "./data/config/urls"
import registerServiceWorker from "./registerServiceWorker";

Sentry.init({
  dsn: SENTRY_DSN,
  environment: process.env.NODE_ENV
});

message.config({
  duration: 2,
  maxCount: 3,
})

notification.config({
  placement: "bottomRight",
  bottom: 50,
  duration: 3,
})

Push.config({
  fallback: function () {
    message.warning("This browser does not support push notification.", 5)
  }
})

if (!Push.Permission.has())
  Push.Permission.request(() => {
    message.success("Notification granted")
  }, () => {
    notification.warn({
      message: "Notification denied",
      description:
        "You will not able to received any notification from dashboard. To grant permission, go to browser settings and allow permission for notifications",
      duration: 0
    })
  })

export const store = configureStore(getInitialStates());

render(
  <AppContainer>
    <Root store={store} history={history} />
  </AppContainer>,
  document.getElementById("chatbot-dashboard-root")
);

if (module.hot) {
  module.hot.accept("./root", () => {
    const NewRoot = require("./root").default;
    render(
      <AppContainer>
        <NewRoot store={store} history={history} />
      </AppContainer>,
      document.getElementById("chatbot-dashboard-root")
    );
  });
}

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js